import React from 'react';

const PageListSkeleton = ({ count = 12 }) => {
  return (
    <div className="w-full">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonRow key={index} />
      ))}
    </div>
  );
};

const SkeletonRow = () => {
  return (
    <div className="relative h-[100px] w-full p-4 flex justify-start items-center bg-white dark:bg-background border-b border-gray-100 dark:border-border">
      <div className="grid md:grid-cols-2 w-full gap-x-4">
        <div className="md:col-span-1 flex items-center">
          <div className="w-[80px] h-[60px] mr-4 rounded bg-gray-100 dark:bg-muted border border-gray-100 dark:border-border animate-pulse flex-shrink-0" />

          <div className="flex-1 min-w-0">
            <div className="h-4 bg-gray-100 dark:bg-muted rounded w-32 mb-2 animate-pulse" />
            <div className="h-3 bg-gray-100 dark:bg-muted rounded w-20 animate-pulse" />
          </div>
        </div>

        <div className="hidden md:flex col-span-1 items-center justify-between">
          <div className="flex-1 grid grid-cols-20 gap-x-4">
            <div className="col-span-4">
              <div className="h-3 bg-gray-100 dark:bg-muted rounded w-16 mb-1 animate-pulse" />
              <div className="h-4 bg-gray-100 dark:bg-muted rounded w-12 animate-pulse" />
            </div>

            <div className="col-span-4">
              <div className="h-3 bg-gray-100 dark:bg-muted rounded w-16 mb-1 animate-pulse" />
              <div className="h-4 bg-gray-100 dark:bg-muted rounded w-10 animate-pulse" />
            </div>

            <div className="col-span-3">
              <div className="h-3 bg-gray-100 dark:bg-muted rounded w-12 mb-1 animate-pulse" />
              <div className="h-4 bg-gray-100 dark:bg-muted rounded w-8 animate-pulse" />
            </div>

            <div className="col-span-3">
              <div className="h-3 bg-gray-100 dark:bg-muted rounded w-8 mb-1 animate-pulse" />
              <div className="h-4 bg-gray-100 dark:bg-muted rounded w-10 animate-pulse" />
            </div>

            <div className="col-span-6">
              <div className="h-3 bg-gray-100 dark:bg-muted rounded w-24 mb-1 animate-pulse" />
              <div className="h-4 bg-gray-100 dark:bg-muted rounded w-12 animate-pulse" />
            </div>
          </div>

          <div className="relative z-10 mr-4 hidden lg:block ml-4">
            <div className="h-9 w-14 bg-gray-100 dark:bg-muted rounded animate-pulse" />
          </div>
        </div>
      </div>

      <div className="h-9 w-8 bg-gray-100 dark:bg-muted rounded animate-pulse ml-2" />
    </div>
  );
};

export default PageListSkeleton;
